<template>
  <v-btn
    v-if="showThemeSwitcher && !mobileMenuMode"
    icon
    class="d-none d-sm-flex"
    @click="handleClick"
  >
    <v-icon 
      :icon="currentIcon"
      color="base-white"
    />
    <v-tooltip
      activator="parent"
      location="bottom"
    >
      <span>{{ tooltip }}</span>
    </v-tooltip>
  </v-btn>

  <v-list-item
    v-if="showThemeSwitcher && mobileMenuMode"
    @click="handleClick"
  >
    <template #prepend>
      <v-icon :icon="currentIcon" />
    </template>
    <v-list-item-title>{{ tooltip }}</v-list-item-title>
  </v-list-item>
</template>

<script>
import { mdiWeatherSunny, mdiWeatherNight } from '@mdi/js'

export default {
  name: 'CrvAppThemeSwitcher',

  props: {
    showThemeSwitcher: {
      type: Boolean,
      default: true,
    },
    tooltip: {
      type: String,
      default: 'Switch theme',
    },
    mobileMenuMode: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:theme'],

  data() {
    return {
      theme: localStorage.getItem('crvThemeDark') === 'true'
        ? 'crvThemeDark'
        : 'crvThemeLight',
    }
  },

  computed: {
    currentIcon() {
      return this.theme === 'crvThemeDark' ? mdiWeatherNight : mdiWeatherSunny
    },
  },

  watch: {
    theme(newVal) {
      const isDark = newVal === 'crvThemeDark'
      localStorage.setItem('crvThemeDark', isDark)
      this.$vuetify.theme.change(newVal)
      this.$emit('update:theme', newVal)
    },
  },

  created() {
    const isDark = this.theme === 'crvThemeDark'
    this.$vuetify.theme.dark = isDark
  },

  methods: {
    handleClick() {
      this.theme =
        this.theme === 'crvThemeDark' ? 'crvThemeLight' : 'crvThemeDark'
    },
  },
}
</script>
